import React from 'react';
import {Button} from "@deere/fuel-react";
import DeleteIcon from "@material-ui/icons/Delete";

export const RatingsDeleteModal = ({titleText, handleClickOpen}) => {
    return (
        <Button variant="text" size="large" style={{marginRight: "1rem"}} onClick={handleClickOpen}>
            <DeleteIcon/>&nbsp; {titleText}
        </Button>
    );
};



